import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CreateForm } from "./CreateForm";
import { Form } from "react-bootstrap";

import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { useTranslation } from "react-i18next";
import { IFleet } from "../interface";
import { AdminFleetService } from "../service";

export const UpdateFleet = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const { t } = useTranslation();
  const [state, setState] = useState<IFleet>({
    name: "",
    text: "",

    category: { name: "" },
  });

  const submitHandler = () => {
    const formData = new FormData();
    formData.append("body", JSON.stringify(state));

    AdminFleetService.update(formData, +id!)
      .then((response) => {
        SuccessToast(t(`settings.successfully_saved`));
        navigate("/admin/fleet");
      })
      .catch((error) => ErrorToast(error));
  };

  return (
    <div className="col-12">
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          submitHandler();
        }}
      >
        <CreateForm categories={categories} state={state} setState={setState} />
      </Form>
    </div>
  );
};
